import {EmailData} from './EmailData'

export type InviteSmeAdminEmailData = EmailData & {
    username: string
    password: string
    passwordValidDays: string
    smeDomainName: string
}
